


























































































































import { Component, Vue } from "vue-property-decorator";
import notificationModule from "./notification-module";
import { NotificationDto } from "./notification-dto";

@Component
export default class Notification extends Vue {
  public menu = false;
  private timer: any = null;

  public created() {
    this.timer = setInterval(() => {
      notificationModule.getAvisos();
    }, 10000);
    notificationModule.getAvisos();
  }

  public beforeDestroy() {
    if (this.timer) clearInterval(this.timer);
  }

  public async NotificacionVista(item: NotificationDto) {
    item.visto = true;
    try {
      await notificationModule.NotificacionVista(item);
      await notificationModule.getAvisos();
    } catch (error) {
      console.error("Error al marcar notificación:", error);
    }
  }

  public get unreadNotifications() {
    return notificationModule.unReadNotifications;
  }

  public cerrar_todas() {
    const promises = this.unreadNotifications.map((ntf) => {
      ntf.visto = true;
      return notificationModule.NotificacionVista(ntf);
    });

    Promise.all(promises).then(() => {
      notificationModule.getAvisos();
    });
  }

  public elapsedTime(startTime: any) {
    if (!startTime) return "ahora";
    let x = new Date(startTime);
    let now = new Date();
    var timeDiff = (now.getTime() - x.getTime()) / 1000;

    if (timeDiff < 60) return "unos segundos";

    var minutes = Math.floor(timeDiff / 60);
    if (minutes < 60) return `${minutes} min`;

    var hours = Math.floor(minutes / 60);
    if (hours < 24) return `${hours} h`;

    var days = Math.floor(hours / 24);
    if (days < 30) return `${days} d`;

    return x.toLocaleDateString();
  }
}
